// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iQWcW6 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 24px;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  min-height: 200px;
}

.xNv4ZA {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  gap: 24px;
}

.TKY2L_ {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 4px;
}

.veFBln {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.42em;
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.W6LSOk {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42em;
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.u0pT8_ {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: 1px;
  border-top: 1px solid #f2f2f2;
}

.AVrGqg {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
  width: 100%;
}

.vAOfIT {
  width: 100%;
}

.BensSe {
  text-align: left;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  height: 25px;
}

@media (max-width: 768px) {
  .BensSe {
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }
}

.MgrxxP {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/AppHome/AppHome.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,iEAAiE;EACjE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 32px 24px;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  min-height: 200px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 544px;\n  gap: 24px;\n}\n\n.welcomeSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 4px;\n}\n\n.greeting {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.42em;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.date {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42em;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.divider {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  height: 1px;\n  border-top: 1px solid #f2f2f2;\n}\n\n.productsSection {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.bannersSection {\n  width: 100%;\n}\n\n.bannersTitle {\n  text-align: left;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  height: 25px;\n}\n\n@media (max-width: 768px) {\n  .bannersTitle {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n}\n\n.pendingActionSection {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iQWcW6`,
	"content": `xNv4ZA`,
	"welcomeSection": `TKY2L_`,
	"greeting": `veFBln`,
	"date": `W6LSOk`,
	"divider": `u0pT8_`,
	"productsSection": `AVrGqg`,
	"bannersSection": `vAOfIT`,
	"bannersTitle": `BensSe`,
	"pendingActionSection": `MgrxxP`
};
module.exports = ___CSS_LOADER_EXPORT___;
